import round from 'lodash/round';

const toPercent = number => number * 100;

// "Designed with Smokers" text animations

function calculateTextTransform(withSmokersScrollProgress) {
  const startingOffset = 40;
  if (withSmokersScrollProgress >= 0.7) {
    // Increment amount subtracted from the offset (up to a max of 40) as scroll progresses.
    const offsetModifier = (withSmokersScrollProgress - 0.7 + 0.1) * 100;
    const offset = startingOffset - offsetModifier;

    return `translateY(${offset}px)`;
  }

  return `translateY(${startingOffset}px)`;
}

// Incrementally updates text opacity after reaching 70% of the scene
function calculateTextOpacity(withSmokersScrollProgress) {
  if (withSmokersScrollProgress >= 0.7) {
    const opacityMultiplier = (withSmokersScrollProgress - 0.7) * 3.33;

    return round(opacityMultiplier, 2);
  }

  return 0;
}

export function textAnimationStyles(withSmokersScrollProgress) {
  return {
    transform: calculateTextTransform(withSmokersScrollProgress),
    opacity: calculateTextOpacity(withSmokersScrollProgress),
  };
}

// Juul Pen image animations

function calculatePenImagePeekTransform(withSmokersScrollProgress) {
  const penImageStartingTransform = 100;
  const minimumTransformValue = 70;
  const transformValue =
    penImageStartingTransform - toPercent(withSmokersScrollProgress * 0.3);

  if (transformValue <= minimumTransformValue) {
    return minimumTransformValue;
  }

  return transformValue;
}

// Calculates translate while scrolling in the simpleClean scene and shows 2/3 of the image while in simpleClean scene
function calculatePenImageShiftingTransform(
  simpleScrollProgress,
  imagePeekTransform,
  cleanScrollProgress
) {
  const transformValue =
    imagePeekTransform - toPercent(simpleScrollProgress * 0.3);

  if (cleanScrollProgress > 0) {
    const transformDifference = transformValue * cleanScrollProgress;

    return transformValue - transformDifference;
  }
  if (transformValue <= 0) {
    return 0;
  }

  return transformValue;
}

function calculateImageScaling(cleanScrollProgress, viewportWidth) {
  let imageMinWidth = 74;
  let imageStartingWidth = 90;

  if (viewportWidth >= 1400) {
    imageMinWidth = 94;
    imageStartingWidth = 182;
  } else if (viewportWidth >= 1024) {
    imageMinWidth = 70;
    imageStartingWidth = 126;
  } else if (viewportWidth >= 768) {
    imageMinWidth = 105;
    imageStartingWidth = 140;
  } else if (viewportWidth >= 375) {
    imageMinWidth = 74;
    imageStartingWidth = 120;
  }

  const widthDifference =
    (imageStartingWidth - imageMinWidth) * cleanScrollProgress;

  return imageStartingWidth - widthDifference;
}

function getPenImageTransform({
  imagePeekTransform,
  imageShiftTransform,
  withSmokersScrollProgress,
  simpleScrollProgress,
}) {
  if (withSmokersScrollProgress > 0 && simpleScrollProgress <= 0) {
    return round(imagePeekTransform, 2);
  }
  if (simpleScrollProgress > 0 && withSmokersScrollProgress >= 1) {
    return round(imageShiftTransform, 2);
  }

  return imagePeekTransform;
}

export function imageWrapperAnimationStyles(
  withSmokersScrollProgress,
  simpleScrollProgress,
  cleanScrollProgress,
  viewportWidth
) {
  const imagePeekTransform = calculatePenImagePeekTransform(
    withSmokersScrollProgress
  );
  const imageShiftTransform = calculatePenImageShiftingTransform(
    simpleScrollProgress,
    imagePeekTransform,
    cleanScrollProgress
  );
  const imageWidth = calculateImageScaling(cleanScrollProgress, viewportWidth);
  const imageTransform = getPenImageTransform({
    imagePeekTransform,
    imageShiftTransform,
    withSmokersScrollProgress,
    simpleScrollProgress,
  });

  return {
    transform: `translateY(${imageTransform}%)`,
    opacity: calculateTextOpacity(withSmokersScrollProgress),
    width: `${imageWidth}px`,
  };
}

// Juul Pod image animations

export function calculatePodImageShiftingTransform(simpleScrollProgress) {
  const startingPosition = -200;
  const transformValue =
    startingPosition + toPercent(simpleScrollProgress * 2.8);

  return transformValue;
}

function calculatePodImageOpacity(simpleScrollProgress) {
  const opacityValue = simpleScrollProgress * 2;
  if (opacityValue >= 1) {
    return 1;
  }

  return opacityValue;
}

export function podImageAnimationStyles(simpleScrollProgress) {
  const podImageShiftTransform = calculatePodImageShiftingTransform(
    simpleScrollProgress
  );

  return {
    transform: `translateY(${podImageShiftTransform}%)`,
    opacity: calculatePodImageOpacity(simpleScrollProgress),
  };
}
